export default __webpack_public_path__ + "maps-examples-style-circles-categorically-960-4708327dd201a35e7eecfbf611856070.png";